import React, { PropTypes } from 'react';
import DateRangePicker from '../../../tc-ui/date-range-picker';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import TcDayPickerSet from '../../../tc-ui/date-picker-set';
import { remove, insert, dissoc } from 'ramda';
import SelectSeasonName from '../select-season-name';
import moment from 'moment';
import R, { prop, addIndex, reject, equals, compose, call, concat, propOr, ifElse, has, filter, nthArg, identity, mapObjIndexed } from 'ramda';
import { seasonNamesMap } from './../../../../utils/contracting-preset-names-codes';
import SyncSectionCheckbox from '../../contract-activities-products/add-edit-dialog-content/sync-section-checkbox';

const	_getDateFromUTC = date => {
  if (!date) return date;
  const dateObject = new Date(date);
  return new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate());
};

const transformDateRanges = dateRanges => {
  return dateRanges.map(dateRange => {
    return Object.keys(dateRange).reduce((result, key) => {
      if (key.indexOf('tartDate') > 0) result.from = _getDateFromUTC(dateRange[key]);
      if (key.indexOf('ndDate') > 0) result.to = _getDateFromUTC(dateRange[key]);
      return result;
    }, {});
  });
};
const getTakenDateRanges = seasonRates => {
  if (!seasonRates) return seasonRates;
  return seasonRates.reduce((result, season) => {
    return result.concat(transformDateRanges(season.dateRanges));
  }, []);
};

const SeasonDates = ({
  updateSeasonWizardWithKeyPath,
  seasonInfo,
  addDateRanges,
  cancelText,
  cancelFunc,
  saveProductInfoChanges,
  existingSeasons,
  selectExistingSeason,
  contractingPeriod,
  backFunc,
  updateFieldWithKeyPath,
  }) => {
  const dateRanges = seasonInfo.dateRanges.map(dateRange => ({
    from: _getDateFromUTC(dateRange.seasonStartDate),
    to: _getDateFromUTC(dateRange.seasonEndDate),
  }));
  const contractingPeriodString = `${moment.utc(contractingPeriod.startDate).format('D MMM YYYY')} - ${moment.utc(contractingPeriod.endDate).format('D MMM YYYY')}`;
  const takenDateRanges = getTakenDateRanges(existingSeasons);
  const systemSeasons = [
    ...Object.keys(seasonNamesMap),
  ]
    .filter(name => name === 'Special Event' || (name && existingSeasons.every(season => season.seasonName !== name)))
    .map(name => ({ seasonName: name, dateRanges: name === contractingPeriodString || name === 'All Year' ? [{ seasonStartDate: contractingPeriod.startDate, seasonEndDate: contractingPeriod.endDate }] : [] }));
  return (
    <div style={{ padding: '24px 24px 0', overflow: 'auto' }}>
      <div style={{ minHeight: '200px'  }}>
        <label style={{ display: 'block', fontSize: '13px', marginLeft: '4px' }}>Please enter or select the season these rates are valid for. </label>
        <div style={{ marginBottom: '12px', width: '460px', fontSize: '13px', float: 'left', display: 'inline-block' }}>
          <label style={{ display: 'block', marginBottom: '8px', marginLeft: '4px', whiteSpace: 'nowrap' }}>If the rates are valid more than once during the year, you can select multiple date ranges.</label>
          <SelectSeasonName
            selectedSeasonName={seasonInfo.selectedSeasonName}
            contractingPeriod={contractingPeriod}
            existingSeasons={existingSeasons}
            onChange={(value) => {
              const selected = systemSeasons.filter(season => season.seasonName === value)[0];
              selectExistingSeason(selected);
            }}
          />
        </div>
        <small style={{ color: 'red', display: 'inline-block', marginTop: '40px', marginLeft: '4px' }}> * Required</small>
        {
          seasonInfo.selectedSeasonName
          && seasonInfo.selectedSeasonName !== contractingPeriodString
          && seasonInfo.selectedSeasonName !== 'All Year'
          && (
            seasonInfo.selectedSeasonName === 'Special Event'
            || existingSeasons.every(season => season.seasonName !== seasonInfo.selectedSeasonName)
          )
          ?
            <div style={{ clear: 'both', display: 'flex', alignItems: 'flex-start' }}>
              <div style={{ width: '550px' }}>
                <DateRangePicker
                  noShowSelected
                  numberOfMonths={6}
                  startDate={contractingPeriod.startDate}
                  endDate={contractingPeriod.endDate}
                  disabledRanges={takenDateRanges}
                  selectedRanges={dateRanges}
                  removeADateRange={i => addDateRanges({ ranges: R.remove(i, 1, seasonInfo.dateRanges.map(range => ({ from: range.seasonStartDate, to: range.seasonEndDate }))) })}
                  onConfirmClick={range => addDateRanges({
                    ranges: seasonInfo.dateRanges.length && range.to
                    ? [...R.dropLast(1, seasonInfo.dateRanges).map(r => ({ from: r.seasonStartDate, to: r.seasonEndDate })), range]
                    : R.append(range,
                      seasonInfo.dateRanges.map(r => ({ from: r.seasonStartDate, to: r.seasonEndDate })),
                    ),
                  })}
                />
              </div>
              <div style={{ width: 'calc(100% - 550px)' }}>
                <small style={{ color: 'red' }}> * At least one date range is required</small>
                <br/>
                {
                  (seasonInfo.dateRanges.length ? seasonInfo.dateRanges : [{}]).map((range, index) => {
                    const currentFromDate = prop('seasonStartDate', range);
                    const currentToDate = prop('seasonEndDate', range);
                    const initialStartDateMonth = (() => {
                      if (currentFromDate) return currentFromDate;
                      if (currentToDate) return currentToDate;
                      if (seasonInfo.dateRanges.length > 1 && index) return seasonInfo.dateRanges[index - 1].seasonEndDate || seasonInfo.dateRanges[index - 1].seasonStartDate;
                      return contractingPeriod.startDate;
                    })();
                    const initialEndDateMonth = (() => {
                      if (currentToDate) return currentToDate;
                      if (currentFromDate) return currentFromDate;
                      if (seasonInfo.dateRanges.length > 1 && index) return seasonInfo.dateRanges[index - 1].seasonEndDate || seasonInfo.dateRanges[index - 1].seasonStartDate;
                      return contractingPeriod.startDate;
                    })();
                    const newTakenRanges = call(compose(
                      concat(takenDateRanges),
                      transformDateRanges,
                      addIndex(reject)((_, filterIndex) => equals(filterIndex, index)),
                      propOr([], 'dateRanges')
                    ), seasonInfo);
                    return (
                      <TcDayPickerSet
                        key={index}
                        showTextField={seasonInfo.selectedSeasonName.toLowerCase() === 'special event'}
                        endDateCloseOnSelect
                        startDateCloseOnSelect
                        disableDeleteButton={seasonInfo.dateRanges.length < 2}
                        textFieldStyle={{ display: 'inline-block', width: '100px', fontSize: '12px' }}
                        startDateContainerStyle={{ display: 'inline-block', marginLeft: '8px', width: 'calc(50% - 80px)' }}
                        startDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
                        endDateContainerStyle={{ display: 'inline-block', width: 'calc(50% - 80px)' }}
                        endDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
                        addButtonStyle={{ marginLeft: '8px', lineHeight: '24px', verticalAlign: 'middle' }}
                        deleteButtonStyle={{ lineHeight: '24px', verticalAlign: 'middle' }}
                        textFieldFloatingText="Event Name"
                        startDateFloatingText="Start Date"
                        endDateFloatingText="End Date"
                        disabledRanges={newTakenRanges}
                        initialStartDateMonth={initialStartDateMonth}
                        startDateEnableFrom={contractingPeriod.startDate}
                        startDateEnableTo={contractingPeriod.endDate}
                        initialEndDateMonth={initialEndDateMonth}
                        endDateEnableFrom={range.seasonStartDate || contractingPeriod.startDate}
                        endDateEnableTo={contractingPeriod.endDate}
                        textFieldValue={range.eventName}
                        startDate={range.seasonStartDate}
                        endDate={range.seasonEndDate}
                        textFieldOnChange={e => updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges', index, 'eventName'], value: e.target.value })}
                        onChangeStartDate={value => updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges', index, 'seasonStartDate'], value })}
                        onChangeEndDate={value => updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges', index, 'seasonEndDate'], value })}
                        onDelete={() => updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges'], value: remove(index, 1, seasonInfo.dateRanges) })}
                        onAdd={() => updateSeasonWizardWithKeyPath({ keyPath: ['dateRanges'], value: !seasonInfo.dateRanges.length ? [{}, {}] : insert(index + 1, {}, seasonInfo.dateRanges) })}
                      />
                    );
                  })
                }
              </div>
            </div> : undefined
        }
        {
          seasonInfo.selectedSeasonName && seasonInfo.selectedSeasonName === contractingPeriodString || seasonInfo.selectedSeasonName === 'All Year' ?
          <div>
            {
              seasonInfo.dateRanges.map((range, index) => (
                <div key={index} style={{ clear: 'both', textAlign: 'left', whiteSpace: 'pre' }}>
                  {`${range.eventName ? `${range.eventName.toUpperCase()}     ` : ''}${moment.utc(range.seasonStartDate).format('D MMM YYYY')} - ${moment.utc(range.seasonEndDate).format('D MMM YYYY')}`}
                </div>)
              )
            }
          </div> : undefined
        }
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px', alignItems: 'center' }}>
        <FlatButton
          label="back"
          secondary
          onTouchTap={backFunc}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <SyncSectionCheckbox
            label="Sync Seasons to Other Products"
            style={{ width: '300px' }}
            sectionInEdit="seasons"
          />
          <div>
            <FlatButton
              label={cancelText}
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              primary
              onTouchTap={cancelFunc}
            />
            <FlatButton
              onTouchTap={() => {
                const seasonInfoWithEmptySetRemoved = mapObjIndexed(
                  ifElse(
                    compose(equals('dateRanges'), nthArg(1)),
                    filter(has('seasonStartDate')),
                    identity
                  ), seasonInfo
                );
                return saveProductInfoChanges(seasonInfoWithEmptySetRemoved);
              }}
              secondary
              disabled={!seasonInfo.seasonName || !seasonInfo.dateRanges.length || (seasonInfo.selectedSeasonName === 'Special Event' && !seasonInfo.dateRanges.filter(range => range.seasonStartDate).length)}
              label="Add Season and Rates"
              loader={seasonInfo.saving}
              labelStyle={{ fontWeight: '600' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

SeasonDates.propTypes = {
  updateFieldValue: PropTypes.func,
  seasonInfo: PropTypes.object,
  addDateRanges: PropTypes.func,
  cancelText: PropTypes.string,
  cancelFunc: PropTypes.func,
  onContinue: PropTypes.func,
  takenDateRanges: PropTypes.array,
  existingSeasons: PropTypes.array,
  selectExistingSeason: PropTypes.func,
  backFunc: PropTypes.func,
};

export default SeasonDates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/4-season-dates.jsx